(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.es = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'No se ha encontrado ningún dato'
      },
      combobox: {
        placeholder: 'Seleccionar',
        searchPlaceholder: 'Buscar'
      },
      datepicker: {
        apply: 'Aplicar',
        clearSelection: 'Borrar',
        pickADays: 'Seleccionar días',
        prevYear: 'Año anterior',
        nextYear: 'Año siguiente',
        prevMonth: 'Mes anterior',
        nextMonth: 'Mes siguiente',
        year: '',
        month1: 'Enero',
        month2: 'Febrero',
        month3: 'Marzo',
        month4: 'Abril',
        month5: 'Mayo',
        month6: 'Junio',
        month7: 'Julio',
        month8: 'Agosto',
        month9: 'Septiembre',
        month10: 'Octubre',
        month11: 'Noviembre',
        month12: 'Diciembre',
        weeks: {
          sun: 'Dom',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Miér',
          thu: 'Jue',
          fri: 'Vier',
          sat: 'Sáb'
        },
        months: {
          jan: 'Ene',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Abr',
          may: 'Mayo',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Ago',
          sep: 'Sep',
          oct: 'Oct',
          nov: 'Nov',
          dec: 'Dic'
        },
        pickADay: 'Seleccione un día'
      },
      timepicker: {
        meridiemAM: 'a. m.',
        meridiemPM: 'p. m.'
      },
      dropdown: {
        noDataMessage: 'No se ha encontrado ningún dato'
      },
      filepicker: {
        browse: 'Examinar',
        select: 'Seleccionar un archivo'
      },
      filter: {
        apply: 'Aplicar',
        cancel: 'Cancelar',
        filterButton: 'Filtro',
        reset: 'Restablecer filtros',
        resetDefault: 'Restablecer valores predeterminados'
      },
      search: {
        noDataMessage: 'No se ha encontrado ningún dato'
      },
      'multi-search': {
        'separator-and': 'Y',
        'search-button': 'Buscar',
        'search-placeholder': 'Buscar por nombre'
      },
      select: {
        all: 'Todos',
        clearSelection: 'Borrar selección',
        noMatch: 'No se ha encontrado ningún dato',
        noData: 'Sin datos',
        placeholder: 'Seleccionar',
        item: 'elemento(s)',
        selected: 'seleccionado',
        found: 'encontrado'
      },
      upload: {
        browseButton: 'Examinar',
        text: 'Arrastre y suelte archivos para cargarlos o haga clic en "Examinar"',
        tip: 'Puede cargar 10 archivos de hasta 25 MB cada uno'
      },
      table: {
        emptyText: 'Sin datos'
      },
      tree: {
        emptyText: 'Sin datos'
      }
    }
  };
  _exports.default = _default;
});